import React from 'react';
import * as S from 'App.styles';
import { useAppSelector } from 'redux/hooks';
import { alertSelectors } from 'redux/modules/Alert';
import { Alert } from 'view/molecules/Alert';
import { calculateSimilarDiscountAlertTitle } from './calculateSimilarDiscountAlertTitle';

export const AlertHandler = () => {
  const title = useAppSelector(alertSelectors.getTitle);
  const isAlertShown = useAppSelector(alertSelectors.isShown);
  const isSimilarDiscountTitle = calculateSimilarDiscountAlertTitle(title);

  return (
    <>
      {isAlertShown && isSimilarDiscountTitle && (
        <S.BlockingPage>
          <Alert centered />
        </S.BlockingPage>
      )}

      {isAlertShown && !isSimilarDiscountTitle && <Alert />}
    </>
  );
};
